import { FormControl } from "@chakra-ui/react";
import React, { useEffect, useMemo, useRef } from "react";
import CustomSelect from "~components/Form/components/Select";
import { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
registerLocale("ptBR", ptBR);
import "react-datepicker/dist/react-datepicker.css";
import useProduto from "~/fetchs/useProduto";
import useGrupoProduto from "~/fetchs/useGrupoProduto";
import PropTypes from "prop-types";

const RotaDoDiaFiltroGraficoCliente = ({ setFilters, filters, filtros, setSelects, selects }) => {
  const formikRef = useRef();
  const filtrosPossiveis = useMemo(() => {
    const grupos = filtros.gruposMateriais;
    const produtos = filtros.produtos;
    return {
      produtos,
      grupos,
    };
  }, [filtros]);

  const { optionGruposProduto, grupoProduto, onChangeGrupoProduto, grupoProdutoSelect } = useGrupoProduto({
    formikRef,
    camposOpt: ["nome"],
    gruposDisponiveis: filtrosPossiveis.grupos,
  });

  const { optionProdutos, onChangeProduto, produtoSelect, produto } = useProduto({
    grupoProduto,
    formikRef,
    produtosDisponiveis: filtrosPossiveis.produtos,
  });

  const optGruposProduto = useMemo(() => {
    optionGruposProduto.unshift({ label: "Todos", value: 0 });
    if (!grupoProduto) grupoProdutoSelect.upDateDefaultValue({ label: "Todos", value: 0 });
    return optionGruposProduto;
  }, [optionGruposProduto]);

  const optProdutos = useMemo(() => {
    optionProdutos.unshift({ label: "Todos", value: 0 });
    if (!produto) produtoSelect.upDateDefaultValue({ label: "Todos", value: 0 });
    return optionProdutos;
  }, [optionProdutos]);

  useEffect(() => {
    if (!selects?.grupoProdutoSelect || !selects?.produtoSelect)
      if (typeof setSelects === "function") setSelects({ grupoProdutoSelect, produtoSelect });
  }, [grupoProdutoSelect, produtoSelect, setSelects]);

  return (
    <div
      data-testid="rota-dia-filtro-grafico-cliente"
      className="flex flex-col md:flex-row items-center md:gap-2 priceSeachFilter__content mb-8"
    >
      <FormControl data-testid="grupo-produto-form-control">
        <CustomSelect
          data-testid="grupo-produto-select"
          className="select-filter focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
          name="grupoProduto"
          label="Grupo de Produtos:"
          placeholder="Grupo de Produtos:"
          options={optGruposProduto}
          spacingControl={true}
          onChange={(e) => {
            onChangeGrupoProduto(e);
            setFilters({ ...filters, grupoMaterialId: e.value });
          }}
          {...grupoProdutoSelect}
        />
      </FormControl>
      <FormControl data-testid="produto-form-control">
        <CustomSelect
          data-testid="produto-select"
          className="select-filter focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
          name="produto"
          label="Produtos:"
          placeholder="Produtos:"
          spacingControl={true}
          options={optProdutos}
          onChange={(e) => {
            onChangeProduto(e);
            setFilters({ ...filters, produtoId: e.value });
          }}
          {...produtoSelect}
        />
      </FormControl>
    </div>
  );
};

RotaDoDiaFiltroGraficoCliente.propTypes = {
  setFilters: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  filtros: PropTypes.object.isRequired,
  setStartDate: PropTypes.func,
  startDate: PropTypes.any,
  faturamentos: PropTypes.any,
  setSelects: PropTypes.func,
  selects: PropTypes.object,
};

export default RotaDoDiaFiltroGraficoCliente;
